import { render } from "./SectorsControl.vue?vue&type=template&id=5fdadc1c&scoped=true&ts=true"
import script from "./SectorsControl.vue?vue&type=script&lang=ts"
export * from "./SectorsControl.vue?vue&type=script&lang=ts"

import "./SectorsControl.vue?vue&type=style&index=0&id=5fdadc1c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdadc1c"]])

export default __exports__